import { authThunkActions } from "src/modules/auth/auth_slice"

const authInit = (store) => {
  store.dispatch(authThunkActions.init())
}
export default authInit
